/**
 * Keeps Aone header cart badges in sync after AJAX cart changes.
 */
(function () {
  'use strict';

  const BADGE_SEL = '.aone-header__cart-badge, .aone-header__util-badge, .header-icon-btn__badge';
  const COUNT_SEL = '.aone-header__utility-cart-count, .aone-header__cart-count, [data-aone-cart-count]';
  const ITEM_WORD_SEL = '[data-aone-cart-item-word]';
  const DEFAULT_CART_URL = '/cart.js';

  /** @param {number} count */
  function syncBadgeDom(count) {
    const value = Math.max(0, count);
    const countStr = String(value);
    const itemWord = value === 1 ? 'item' : 'items';

    document.querySelectorAll(BADGE_SEL).forEach((el) => {
      el.textContent = countStr;
    });
    document.querySelectorAll(COUNT_SEL).forEach((el) => {
      el.textContent = countStr;
    });
    document.querySelectorAll(ITEM_WORD_SEL).forEach((el) => {
      el.textContent = itemWord;
    });

    try {
      sessionStorage.setItem(
        'cart-count',
        JSON.stringify({ value: countStr, timestamp: Date.now() })
      );
    } catch (_) {
      // no-op
    }
  }

  /**
   * @param {{ item_count?: number }} cart
   * @param {string} [sourceId]
   */
  function publishCartUpdate(cart, sourceId) {
    const count = typeof cart.item_count === 'number' ? cart.item_count : 0;
    syncBadgeDom(count);
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: sourceId || 'aone-cart-count',
          data: { itemCount: count },
        },
      })
    );
  }

  /**
   * @param {string} [cartUrl]
   * @param {string} [sourceId]
   */
  async function fetchAndPublish(cartUrl, sourceId) {
    const url = cartUrl || DEFAULT_CART_URL;
    const res = await fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) throw new Error('cart.js failed');
    const cart = await res.json();
    publishCartUpdate(cart, sourceId);
    return cart;
  }

  let fetching = false;

  document.addEventListener('cart:update', (e) => {
    const detail = /** @type {{ resource?: { item_count?: number }, data?: { didError?: boolean } } | undefined} */ (
      e.detail
    );
    if (!detail || detail.data?.didError) return;

    const count = detail.resource?.item_count;
    if (typeof count === 'number') {
      syncBadgeDom(count);
      return;
    }

    if (fetching) return;
    fetching = true;
    fetchAndPublish()
      .catch(() => {})
      .finally(() => {
        fetching = false;
      });
  });

  window.aoneCartCount = {
    syncBadgeDom,
    publish: publishCartUpdate,
    fetchAndPublish,
  };
})();
